import { initializeCarousels } from "./components/carousels";
import { initializeHeader } from "./components/header";
import { initializeContent } from "./components/content";
import { initializeAnimations } from "./components/animations";
const start = () => {
    for (const initialize of [initializeHeader, initializeCarousels, initializeContent, initializeAnimations]) {
        try {
            initialize();
        }
        catch (error) {
            console.error("Vadelma component failed:", error);
        }
    }
    window.__hideVadelmaPreloader?.();
};
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
}
else {
    start();
}
